
<div
    [formGroup]="form"
    class="agpr-brandSocialLinks"
>
    <div class="agpr-brandSocialLinks-header">
        <label class="agpr-brandSocialLinks-header-label">
            {{ 'Common.brandInformation.socialLinks.label' | localize }}
        </label>
        <agpr-button
            [id]="id + '_add'"
            [style]="buttonTypes.icon"
            [icon]="'fa-regular fa-duotone fa-square-plus'"
            (click)="add()"
            [tooltip]="'Common.brandInformation.socialLinks.add'"
            [tooltipPosition]="'left'"
            [disabled]="disabled || value.length >= maxLimit"
        ></agpr-button>
    </div>

    @if (socialLinks.controls.length) {
        <ul
            formArrayName="socialLinks"
            class="agpr-brandSocialLinks-list"
            agprListKeyboardNavigation
        >
            @for (group of socialLinks.controls; track group; let i = $index) {
                <li
                    #listItem
                    [formGroupName]="i"
                    class="agpr-brandSocialLinks-listItem agpr-contextMenu-parent"
                >
                    <div class="agpr-brandSocialLinks-card">
                        <agpr-dropdown
                            formControlName="type"
                            [id]="id + '_linkType_' + i"
                            label="Common.brandInformation.socialLinks.linkType"
                            [options]="linkTypesOptions"
                            [bindToValue]="true"
                        ></agpr-dropdown>
                        <div>
                            <agpr-text-input
                                formControlName="url"
                                [id]="id + '_url_' + i"
                                label="Common.brandInformation.socialLinks.url"
                                placeholder="Common.brandInformation.socialLinks.url.placeholder"
                                [required]="true"
                                [bottomMargin]="false"
                            ></agpr-text-input>
                            @if (group.get('url')?.hasError('required')) {
                                <agpr-form-message
                                    [id]="id + '_emptyUrlError'"
                                    [marginBottom]="0"
                                >
                                    {{ 'Common.brandInformation.socialLinks.url.empty' | localize }}
                                </agpr-form-message>
                            }
                            @if (group.get('url')?.hasError('pattern')) {
                                <agpr-form-message
                                    [id]="id + '_invalidUrlError'"
                                    [marginBottom]="0"
                                >
                                    {{ 'Common.brandInformation.socialLinks.url.invalid' | localize }}
                                </agpr-form-message>
                            }
                        </div>
                        <agpr-text-input
                            formControlName="text"
                            [id]="id + '_linkText_' + i"
                            label="Common.brandInformation.socialLinks.linkText"
                            placeholder="Common.brandInformation.socialLinks.linkText.placeholder"
                            [bottomMargin]="false"
                        ></agpr-text-input>
                    </div>
                    <div class="agpr-contextMenu top right">
                        <agpr-button
                            [id]="id + '_remove_' + i"
                            class="agpr-brandSocialLinks-removeButton"
                            [style]="buttonTypes.contextMenu"
                            [icon]="'fa-regular fa-duotone fa-square-xmark'"
                            [tooltip]="'Common.brandInformation.socialLinks.button.remove'"
                            [tooltipPosition]="'left'"
                            (click)="remove(i)"
                            [disabled]="disabled"
                        ></agpr-button>
                    </div>
                </li>
            }
        </ul>
    } @else {
        <agpr-message
            [id]="id + '_nosocialLinksMessage'"
            class="agpr-brandSocialLinks-noSocialLinksMessage"
            [severity]="messageSeverity.noContent"
            [bottomMargin]="false"
        >
            {{ 'Common.brandInformation.socialLinks.noSocialLinksMessage' | localize}}
        </agpr-message>
    }
</div>



